/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class GamesService {
  constructor(private httpClient: HttpClient) {}

  addMeToGameTeam(teamId: number) {
    return this.httpClient.post(`${environment.apiHostname}/v1/teams/${teamId}/add-me`, {});
  }

  removeMeFromGameTeam(teamId: number) {
    return this.httpClient.post(`${environment.apiHostname}/v1/teams/${teamId}/remove-me`, {});
  }

  getGame(gameId: number) {
    return this.httpClient.get(`${environment.apiHostname}/v1/games/${gameId.toString()}`).pipe(
      map((response: any) => {
        if (response.result.success) {
          return response.data;
        } else {
          throw new Error(response.result.message);
        }
      })
    );
  }

  getGamesByUserId(userId: number) {
    return this.httpClient.get(`${environment.apiHostname}/v1/games/by-user/${userId.toString()}`).pipe(
      map((response: any) => {
        if (response.result.success) {
          return response.data;
        } else {
          throw new Error(response.result.message);
        }
      })
    );
  }

  getTagActionsByGameId(gameId: number) {
    return this.httpClient
      .get(`${environment.apiHostname}/v1/tag-actions/by-game/${gameId.toString()}?publishedOnly=true`)
      .pipe(
        map((response: any) => {
          if (response.result.success) {
            return response.data;
          } else {
            throw new Error(response.result.message);
          }
        })
      );
  }
}
